/* src/app/components/controls/dialogs/sem-treeview-dialog/sem-treeview-dialog.component.css */
.tree-node-not-selectable {
  cursor: default;
  color: #6b7280;
}
/*# sourceMappingURL=sem-treeview-dialog.component.css.map */
